// This file was generated using `pay js:run gql-v1 --type=lazy-query --name=RetrieveFile --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

import type {
  V1LazyQueryOptionsWithoutVariables,
  V1LazyQueryOptions,
  V1LazyQueryReturn,
  V1PermissionToken,
} from '@stripe-internal/data-v1/types';
import {useV1LazyQuery} from '@stripe-internal/data-v1';
import {gql} from '@sail/data';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';

import type {
  Exact,
  Scalars,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';
import {stripeFileFragment} from './stripeFileFragment';

import type {StripeFileFragmentData} from './stripeFileFragment';

const doc = gql`
  query RetrieveFileQuery($fileId: String!, $v1Context: V1ContextInput!) {
    v1FilesFile(input: {file: $fileId}, v1Context: $v1Context) {
      id
      ...StripeFileFragment
    }
  }

  ${stripeFileFragment}
`;

export const retrieveFileLazyQuery: RetrieveFileLazyQueryDocument = doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const retrieveFileLazyQueryOptions: V1LazyQueryOptionsWithoutVariables<RetrieveFileLazyQueryDocument> =
  {
    // expectedErrors: [],
    // mutedErrors: [],
    // fetchPolicy: 'cache-first',
    // ...
  };

export default function useRetrieveFileLazyQuery(
  options: V1LazyQueryOptions<RetrieveFileLazyQueryDocument> = {},
): V1LazyQueryReturn<RetrieveFileLazyQueryDocument> {
  return useV1LazyQuery(
    retrieveFileLazyQuery,
    Object.assign({}, retrieveFileLazyQueryOptions, options),
  );
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type RetrieveFileLazyQueryVariables = Exact<{
  fileId: Scalars['String'];
  v1Context: V1ContextInput;
}>;

export type RetrieveFileLazyQueryData = {
  readonly __typename: 'Query';
  readonly v1FilesFile: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiFile'; readonly id: string},
    [StripeFileFragmentData]
  > | null;
};

const retrieveFileLazyQueryPermissions = {
  ...stripeFileFragment.permissions,
} as const;

doc.permissions = retrieveFileLazyQueryPermissions;

export type RetrieveFileLazyQueryPermissions = V1PermissionToken<
  typeof retrieveFileLazyQueryPermissions
>;

export type RetrieveFileLazyQueryDocument = GraphQlDocument<
  RetrieveFileLazyQueryData,
  RetrieveFileLazyQueryVariables,
  RetrieveFileLazyQueryPermissions
>;
